import commonUrl from "@/lib/commonUrl.js";
import { getUserDetail } from "@/api/service/userInfoApi";
// IM连接回调
function childCallback() {}
const UserInfo = {
  state: {
    userInfo: {} // 用户信息
  },
  mutations: {
    // 保存用户信息
    SET_USERINFO(state, info) {
      state.userInfo = info;
    }
  },
  actions: {
    saveUserInfo: ({ commit, rootState, dispatch }) => {
      return new Promise((resolve, reject) => {
        getUserDetail({
          token: window.sessionStorage.getItem('token')
        }).then(response => {
          if (response.data.data) {
            let data = response.data.data;
            data.token = window.sessionStorage.getItem('token');
            commit("SET_USERINFO", data || {});
            // commonUrl.imurl = "https://sit.apbenben.com"; //  https://im.apbenben.com
            rootState.IMframe.imFrameSrc =
            `${commonUrl.imurl}/#/contactshowview?ptype=1&code=${data.id}&name=${data.businessName} - ${data.userName}&portraitUri=&remark=${data.businessName}` +
            `&landline=${data.landline}&sign=${
              data.token
            }&callback=${encodeURIComponent(childCallback)}`;
          /* rootState.IMframe.imFrameSrc =
                  `http://127.0.0.1:8080/#/contactshowview?ptype=1&code=${data.id}&name=${data.businessName} - ${data.userName}&portraitUri=&remark=${data.businessName}` +
                  `&landline=${data.landline}&sign=${
                    data.token
                  }&callback=${encodeURIComponent(childCallback)}`; */
          // 供应商--判断是否含有旗舰店
          /* if (
                  data.companyType === 2 ||
                  data.companyType === 3 ||
                  data.companyType === 4
                ) {
                  commit("SET_ISFLAGSHIP", data.memberId);
                  dispatch("getShopCoopUnRead");
                } */
          } 
          /* else {
            document.cookie = "barrageStatus = 0; path=/"; // 设置开启弹幕
            document.cookie = "sideBarStatus = 0; path=/"; // 设置开启浮层广告
            if (window.localStorage) {
              localStorage.setItem("taskBuoyStatus", 0); // 设置任务浮层
            }
          } */
          // resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
};

export default UserInfo;
